// 与 src/haruhiloop_cli/ending_epilogues.py 1:1 对齐。

export const EPILOGUES: Record<string, string> = {
  haruhi_happy_new_world:
    "你们终于把「为什么又是同一天」说透了，也把该补的窟窿一个个填上。企划表上的彩笔干了又湿，" +
    "作业本合上时发出清脆的一声，像某种封印被解除。窗外云层的走向与昨天不同——不是错觉，" +
    "是气象图真的歪了一格。有人笑，有人发呆，有人偷偷把日历撕下一角夹进书里。" +
    "循环没有宣布退休，但它第一次显得有点礼貌，像愿意在门口等你们把鞋穿好再跟上来。",
  consensus_paradise:
    "会议室的白板上写满了「已对齐」「可执行」「风险可控」。真相被切成适合吞咽的份量，" +
    "希望信号变成例会上的固定议程。没有人再失眠，因为失眠也被排进了「个人效率优化」里。" +
    "世界稳定得近乎无菌：闭锁退成背景噪声，线索在表格里乖乖排队。你忽然意识到，" +
    "最可怕的不是循环本身，而是所有人都真心相信——我们已经处理好了。窗外仍是同一天，" +
    "只是阳光被调成了护眼模式。",
  kyon_breaks_loop:
    "异常、作业与那句说不出口的话终于叠在同一条时间线上。你们不再用「巧合」糊弄自己，" +
    "也不再指望某个英雄人物独自扛下所有解释。裂缝出现时没有配乐，只有空调突然停了一秒，" +
    "所有人的呼吸跟着对齐。第二天醒来，手机日历上的数字往前跳了一格——小得几乎可笑，" +
    "却重得像第一次登陆。你们没有庆祝，只是默默把重复了无数次的早餐换了一种果酱。",
  meltdown_pact:
    "真相像被拉到正午广场的太阳灯：谁也别想装作没看见。闭锁的余震还在墙里爬，" +
    "你们却已经开始了互相指证的圆桌会议。每一句话都正确，正确得像刀片。" +
    "稳定度在尖叫，情绪在硬撑，共识碎成一地玻璃碴，每一片都反射着「我是为你好」。" +
    "没有人被怪物拖走——更糟的是，你们自己把门焊上，只留下一条通风口用来继续争吵。" +
    "循环还在转，只是转速表已经进了红区。",
  hollow_celebration:
    "气球、横幅与排练过十七次的口号把体育馆撑得满满当当。镜头里每个人都笑得很标准，" +
    "标准到像从同一个模板里抠出来的。没有人提起循环，因为赞助商名单上没这一栏。" +
    "满意度在高位漂浮，像糖霜下面其实没有蛋糕。夜里你独自收拾彩带，发现垃圾桶里" +
    "塞满了未拆封的「惊喜」——原来热闹可以量产，而孤独不行。天亮以后，日历照旧，" +
    "只是你突然听懂了那种安静：不是和平，是空心的回声。",
  archive_bound:
    "卷宗厚到能当枕头，推论链长到可以绕操场三圈。你们把世界拆成变量，再把变量拼成牢笼。" +
    "稳定度没有归零，于是没有人为灾难负责——只有无穷无尽的附录、脚注与待办。" +
    "真相当然在，但它被埋在交叉引用第 409 条后面，连你们自己翻回去都要迷路。" +
    "闭锁像退潮一样远去，留下一片过于平整的沙滩，上面只有一行脚印，却看不出是谁的。" +
    "循环成了脚注里的脚注：你们赢了逻辑，输给了重量。",
  observer_bailout:
    "你记下了每一次偏差、每一条异常、每一种可能解释，却迟迟不肯把手伸进齿轮里。" +
    "世界线偏移数像里程表一样狂跳，满意度却停在「还可以」的温吞区——像一杯忘了喝的水。" +
    "有一天你发现自己在删笔记：不是因为它错了，而是因为你终于承认，记录并不会自动等于拯救。" +
    "循环没有惩罚你，它只是把你留在观众席，灯亮着，戏散场，你站起来鼓掌，掌声很轻。" +
    "走出去时，门口的风和昨天一样，但你口袋里多了一枚硬币，正反面你都不想再看。",
  nagato_collapse:
    "她最后一次点头时，瞳孔里已经没有对焦的对象，像在直视一段自我递归的错误日志。" +
    "你递过去的异常清单在空气中碎成像素，图书馆的灯管一齐闪烁，频率整齐得像心跳被接管。" +
    "没有人听见爆炸声——只有书架深处传来无限次「对不起」的叠加态，轻得像纸张摩擦。" +
    "循环没有停，但「长门有希」这个名字从索引里被温柔地抹去了，只留下一行未定义行为，" +
    "从此每次你抬头看表，秒针都会先倒退一格，再假装若无其事地往前走。",
  shinirappears_unstable_world:
    "稳定度像被抽掉的桌布，上面的杯子终于一起摔碎。闭锁不再是隐喻，而是走廊尽头" +
    "那团吞光的形状，带着低频嗡鸣向你们靠近。有人尖叫，有人笑出声来，有人试图用旧公式" +
    "去套新怪物——公式融化了。满意度跌穿底线时，世界不再假装讲理：它直接改写了物理层的注释。" +
    "你们曾以为最坏结局是「再来一次」；现在才明白，最坏的是「这一次不再像任何一次」。" +
    "循环没有结束，它只是露出了牙齿。",
};

export function epilogueFor(endingId: string): string {
  return EPILOGUES[endingId] ?? "";
}
